import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdatePortalCustomCss(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation(
    "put",
    "/shops/{shopId}/preferences/custom-css",
    {
      invalidate: invalidateShop,
      mapVariables: (customCss: string) => ({
        params: { path: { shopId: shop.id } },
        body: { value: customCss },
      }),
    },
  );
}
